import React from "react";
import { LinkButton, Text, Wrapper } from "@networkraildigitalfactory/components";
import { CheckCircle, XCircle } from "phosphor-react";
import useAdminStore from "../../stores/useAdminStore";
import styles from "./About.module.css";

const About = (props) => {
  const { setIsOnboardingModalOpen, setIsWhatsNewModalOpen } = props;
  const isAdmin = useAdminStore((state) => state.isAdmin);

  return (
    <Wrapper maxWidth={1200} align="left">
      <div className={styles.header}>
        <Text wrapper="span" type="header">
          About
        </Text>
      </div>
      <div className={styles.row}>
        <Text wrapper="h2" type="subtitle" color="#727272">
          Overview
        </Text>
        <Text wrapper="span" type="body">
          iPerform is Network Rail IT's performance review tool. iPerform allows employees and
          managers to set objectives and track progress against these objectives. In future releases
          of iPerform, users will be able to submit prep for their 1-2-1's, as well as view and send
          feedback.
        </Text>
      </div>
      <div className={styles.row}>
        <Text wrapper="h2" type="subtitle" color="#727272">
          Support
        </Text>
        <Text wrapper="p" type="body">
          For all questions and support enquiries please contact the Network Rail IT Helpdesk by
          calling:
        </Text>
        <Text wrapper="p" type="body">
          Internal{" "}
          <a id="tabToMe" aria-label="085 51600" href="tel: 085 51600" className={styles.link}>
            085 51600
          </a>
        </Text>
        <Text wrapper="p" type="body" style={{ marginBottom: 0 }}>
          External{" "}
          <a aria-label="01270 721600" href="tel: 01270 721600" className={styles.link}>
            01270 721600
          </a>
        </Text>
      </div>
      <div className={styles.row}>
        <Text wrapper="h2" type="subtitle" color="#727272">
          Supported browsers
        </Text>
        <Text wrapper="p" type="body">
          We will no longer be supporting Google Chrome, Internet Explorer or Microsoft Edge (Pre
          Chromium). We will only be supporting Microsoft Edge (Chromium) going forward. This will
          enable us to provide the best user experience possible on the Network Rail supported
          browser.
        </Text>
        <div className={styles.browser_wrapper}>
          <div className={styles.browser_col}>
            <div className={styles.icon_text}>
              <CheckCircle size={28} color="#3D9F09" />
              <Text type="body">Microsoft Edge (Chromium)</Text>
            </div>
          </div>
          <div className={styles.browser_col}>
            <div className={styles.icon_text}>
              <XCircle size={28} color="#FB3049" />
              <Text type="body">Microsoft Edge (Pre Chromium)</Text>
            </div>
            <div className={styles.icon_text}>
              <XCircle size={28} color="#FB3049" />
              <Text type="body">Internet Explorer</Text>
            </div>
            <div className={styles.icon_text}>
              <XCircle size={28} color="#FB3049" />
              <Text type="body">Google Chrome</Text>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.row}>
        <Text wrapper="h2" type="subtitle" color="#727272">
          Feedback
        </Text>
        <Text wrapper="p" type="body">
          We cannot improve iPerform without feedback from our users. If you want to share feedback
          with us, please use our feedback form below.
        </Text>
        <Text wrapper="span" type="body">
          <a
            href="https://forms.office.com/Pages/ResponsePage.aspx?id=4cMswn9dTU--A9WhWMyUCUiXVSSmgJtOrhA8lgFoOyJUME5XVVRaWE9ZMkFaRDFUSkMxOEM2NEFMTS4u"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            Feedback form
          </a>
        </Text>
      </div>
      <div className={styles.row}>
        <Text wrapper="h2" type="subtitle" color="#727272">
          Useful links
        </Text>
        <div className={styles.button_links_group}>
          <div className={styles.statements_wrapper}>
            {isAdmin && (
              <>
                <LinkButton
                  onClick={() => {
                    setIsOnboardingModalOpen(true);
                  }}
                  name="Onboarding"
                  style={{ fontSize: "18px", height: "auto", padding: 0, margin: "0.2rem 0" }}
                >
                  Onboarding
                </LinkButton>
                <LinkButton
                  onClick={() => {
                    setIsWhatsNewModalOpen(true);
                  }}
                  name="Whats new"
                  style={{ fontSize: "18px", height: "auto", padding: 0, margin: "0.2rem 0" }}
                >
                  What's New
                </LinkButton>
              </>
            )}
            <a
              href="https://public.nrdigital.co/faq/iPerform+FAQs+v2.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Frequently Asked Questions
            </a>
            <a
              href="https://networkrailmobile-gdpr.s3.eu-west-2.amazonaws.com/iPerform-PrivacyStatement.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Statement
            </a>
            <a
              href="https://public.nrdigital.co/accessibility/iPerform/iPerform+Accessibility+Statement.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Accessibility Statement
            </a>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default About;
